import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Services from '../components/Services';
import { FiArrowRight } from 'react-icons/fi';

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Accueil", "item": "https://limousine-vip-paris.fr/" },
    { "@type": "ListItem", "position": 2, "name": "Services", "item": "https://limousine-vip-paris.fr/services" }
  ]
};

const itemListSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Services de location de limousine VIP Limousine Paris",
  "itemListElement": [
    "Limousine pour mariage à Paris",
    "Transfert aéroport Roissy CDG en limousine",
    "Transfert aéroport Orly en limousine",
    "Limousine EVJF / EVG à Paris",
    "Limousine pour Disneyland Paris",
    "Limousine pour le Château de Versailles",
    "Limousine d'anniversaire à Paris",
    "Limousine pour bal de promo",
    "Tour de Paris en limousine VIP",
    "Soirée VIP, casino, restaurant en limousine",
    "Shooting photo, clip vidéo, court-métrage",
    "Transport corporate et événements d'affaires"
  ].map((label, i) => ({
    "@type": "ListItem",
    "position": i + 1,
    "name": label
  }))
};

const linkedServices = [
  { slug: '/limousine-mariage-paris', label: 'Limousine Mariage Paris' },
  { slug: '/transfert-aeroport-roissy-cdg', label: 'Transfert Roissy CDG' },
  { slug: '/transfert-aeroport-orly', label: 'Transfert Orly' },
  { slug: '/limousine-evjf-paris', label: 'EVJF Paris' },
  { slug: '/limousine-disneyland-paris', label: 'Disneyland Paris' },
  { slug: '/limousine-versailles', label: 'Versailles' },
  { slug: '/limousine-anniversaire-paris', label: 'Anniversaire Paris' },
  { slug: '/limousine-bal-de-promo-paris', label: 'Bal de promo' }
];

const ServicesPage = () => {
  return (
    <>
      <Helmet>
        <title>Services de Limousine à Paris - Mariage, Aéroport, EVJF, VIP | VIP Limousine</title>
        <meta name="description" content="Tous nos services de location de limousine avec chauffeur à Paris : mariage, transfert aéroport CDG/Orly, EVJF, anniversaire, bal de promo, tour VIP. Devis gratuit 24/7." />
        <link rel="canonical" href="https://limousine-vip-paris.fr/services" />
        <meta property="og:title" content="Services de Limousine à Paris - VIP Limousine" />
        <meta property="og:description" content="Mariage, aéroport, EVJF, anniversaire : tous nos services de location limousine à Paris." />
        <meta property="og:url" content="https://limousine-vip-paris.fr/services" />

        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(itemListSchema)}</script>
      </Helmet>

      <div style={{ paddingTop: '100px' }}>
        <Services />

        <section className="section-padding" style={{ background: 'rgba(0,0,0,0.4)' }}>
          <div className="container">
            <div className="section-header text-center">
              <span className="section-badge">Pages dédiées</span>
              <h2 className="section-title">
                Découvrez chaque service en détail
                <span className="title-accent">avec tarifs et FAQ</span>
              </h2>
              <p className="section-description">
                Pour chaque type d'événement, nous avons conçu une page dédiée avec véhicules
                recommandés, prestations incluses, tarifs forfaitaires et questions fréquentes.
              </p>
            </div>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
              gap: '0.75rem'
            }}>
              {linkedServices.map((s) => (
                <Link
                  key={s.slug}
                  to={s.slug}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0.9rem 1.1rem',
                    background: 'rgba(255,255,255,0.05)',
                    border: '1px solid rgba(212,175,55,0.2)',
                    borderRadius: '0.75rem',
                    color: 'var(--text-primary)',
                    textDecoration: 'none',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = 'var(--primary-gold)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(212,175,55,0.2)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <span>{s.label}</span>
                  <FiArrowRight color="var(--primary-gold)" />
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ServicesPage;
